import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { LoginSchema } from "../../../lib/validations/uservalidation";
import { loginServer } from "../../../apis/loginApi";
import { LoginValues } from "../../../lib/initialvalues/initialvalues";
// import ToastMessage from "../../../lib/common/ToastMessage";
const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: LoginValues,
    validationSchema: LoginSchema,
    onSubmit: async (userValues) => {
      try {
        console.log(props)
        setLoading(true);
        const res = await loginServer(userValues);
        if (res.data.success === true) {
          console.log(props)
            navigate("/news");
         
        } else {
          setErrorMessage(res.data.message);
          setLoading(false);
        }
      } catch (err) {
        setErrorMessage("An error occurred while logging in");
        setLoading(false);
      }
    },
  });
  const handleChange = (e) => {
    const value = e.target.value;
    formik.setFieldValue("email", value.toLowerCase());
  };
  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              <div className="account-logo"></div>
              <div className="account-box">
                <div className="account-wrapper">
                  <h3 className="account-title">Login</h3>
                  {errorMessage && (
                    <p
                      className={
                        errorMessage === "Login successfully"
                          ? "text-success text-center"
                          : "text-danger text-center"
                      }
                      style={{
                        fontSize: "16px",
                      }}
                    >
                      {errorMessage}
                    </p>
                  )}
                  <div>
                    <form onSubmit={formik.handleSubmit}>
                      <div className="input-block mb-4">
                        <label className="col-form-label">Email Address</label>
                        <input
                          className="form-control form-control-lg"
                          type="text"
                          name="email"
                          value={formik.values.email}
                          onChange={handleChange}
                          onBlur={formik.handleBlur}
                          autoComplete="true"
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div className="text-danger">
                            {formik.errors.email}
                          </div>
                        )}
                      </div>
                      <div className="input-block mb-4">
                        <div className="row">
                          <div className="col">
                            <label className="col-form-label">Password</label>
                          </div>
                          <div className="col-auto">
                            <Link className="text-primary" to="/forgot">
                              Forgot password?
                            </Link>
                          </div>
                        </div>
                        <div style={{ position: "relative" }}>
                          <input
                            type="password"
                            className="form-control form-control-lg"
                            name="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.password &&
                            formik.errors.password && (
                              <div className="text-danger">
                                {formik.errors.password}
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="input-block">
                        {loading ? (
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: "50px", padding: "7px 30px" }}
                          >
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        ) : (
                          <button
                            className="btn btn-primary account-btn"
                            type="submit"
                          >
                            Login
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {
      toast &&(
       <ToastMessage
        backgroundColor='green'
        message="sfjlsdjfjds"
         />  
     ) } */}
    </div>
  );
};

// const dataDispatch = (payLoad, dispatch) => {
//   return {
//     sendMessage: (message) =>{
//       dispatch({ type: 'sendMessage', message})
//     } 
//   } 
// }

export default Login;
